export default __webpack_public_path__ + "static/media/285hz-immune-system-booster.cb30b011.jpg";